import { useMemo } from 'react';

import { useLocale } from './useLocale';

import { IPlantDetails, ISEOOptions, SeoImage } from '@/types';

interface IUsePlantSeo {
  seoOptions: ISEOOptions;
  plantName: string;
}

export const usePlantSeo = (plantDetails: IPlantDetails | null): IUsePlantSeo => {
  const { isEnLocale } = useLocale();

  const plantName = useMemo<string>(() => {
    const { name = '', name_en = '' } = plantDetails ?? {};
    return isEnLocale ? name_en : name;
  }, [isEnLocale, plantDetails]);

  const seoOptions = useMemo<ISEOOptions>(() => {
    if (!plantDetails) {
      return {} as ISEOOptions;
    }

    const { features, useful_properties, images } = plantDetails;

    const SEOImages: SeoImage[] = images.map(({ img: url }) => ({ url }));

    return {
      title: plantName,
      description: `${features}. ${useful_properties}`,
      images: SEOImages,
      thumbnail: images?.find((image) => image.is_main)?.img,
    };
  }, [plantDetails, plantName]);

  return { seoOptions, plantName };
};
